import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Layout from './Layout';
import axiosInstance from '../axiosConfig';
import { colors } from '../colors';

const LoginPage = () => {
  const [loginData, setLoginData] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post('/api/auth/signin', loginData);
      sessionStorage.setItem('token', response.data.accessToken);
      sessionStorage.setItem('userId', response.data.username);
      navigate('/admin/dashboard'); // Redirect to Admin Dashboard
    } catch (error) {
      setError('Login failed. Please check your credentials.');
    }
  };

  return (
    <Layout>
      {/* Blue Banner */}
      <Box
        sx={{
          backgroundColor: colors.primaryBannerBlue,
          color: 'white',
          padding: { xs: '5px 0', sm: '10px 0' }, // Responsive padding
          textAlign: 'center',
          fontSize: { xs: '1rem', sm: '1.2rem' },
          fontWeight: '500',
        }}
      >
        SIGN IN
      </Box>
      <Container
        maxWidth="lg"
        sx={{
          minHeight: '100vh', // Ensures the container spans the entire viewport height
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: { xs: '20px', md: '30px' }, // Adjust margin based on screen size
          paddingTop: { xs: '10px', md: '20px' }, // Optional padding to handle spacing
        }}
      >
        {/* Main Container */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' }, // Stacks on small screens
            justifyContent: 'center',
            alignItems: 'stretch', // Ensures both sides stretch to equal height
            width: '100%',
            backgroundColor: '#FFF',
            borderRadius: '12px',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
          }}
        >
          {/* Left Part: Login Form */}
          <Box
            sx={{
              flex: 1,
              padding: '40px',
              backgroundColor: '#F5F5F5', // Light grey background
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center', // Center the content
              minHeight: { xs: '60vh', md: '50vh' }, // Adjust height for responsiveness
            }}
          >
            <Typography
              variant="h4"
              sx={{
                textAlign: 'center',
                marginBottom: '20px',
                fontWeight: 'bold',
                color: '#1E2742',
              }}
            >
              Welcome Back!
            </Typography>
            <Typography
              variant="body1"
              sx={{
                textAlign: 'center',
                marginBottom: '30px',
                color: '#555',
              }}
            >
              Sign in to your account to access our exclusive surveys and analytics tools.
            </Typography>
            <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: '400px' }}>
              <TextField
                fullWidth
                label="Username"
                name="username"
                value={loginData.username}
                onChange={handleChange}
                margin="normal"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                  },
                }}
              />
              <TextField
                fullWidth
                label="Password"
                name="password"
                type="password"
                value={loginData.password}
                onChange={handleChange}
                margin="normal"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                  },
                }}
              />
              {error && (
                <Typography
                  color="error"
                  sx={{
                    textAlign: 'center',
                    marginTop: '10px',
                    fontWeight: 'bold',
                  }}
                >
                  {error}
                </Typography>
              )}
              <Button
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: '#BC2534', // Custom color
                  color: '#fff', // Text color
                  '&:hover': {
                    backgroundColor: '#A6202E', // Hover effect
                  },
                  marginTop: '20px',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                }}
                fullWidth
              >
                Sign In
              </Button>
            </form>
            <Box sx={{ marginTop: '30px', textAlign: 'center' }}>
              <Typography
                variant="body2"
                sx={{
                  color: '#777',
                  marginTop: '10px',
                }}
              >
                Forgot your password?{' '}
                <Button
                  variant="text"
                  sx={{
                    color: '#BC2534',
                    fontWeight: 'bold',
                    padding: 0,
                  }}
                >
                  Click here
                </Button>
              </Typography>
            </Box>
          </Box>

          {/* Right Part: Details */}
          <Box
            sx={{
              flex: 1,
              padding: '20px',
              backgroundColor: '#1E2742',
              color: '#FFF',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/LoginPage.webp`} // Replace with your actual image URL
              alt="Welcome"
              sx={{
                border: '2px solid #BC2534', // Red border for emphasis
                width: '100%', // Adjusted for responsive design
                maxWidth: '500px', // Maximum width for larger screens
                height: 'auto',
                borderRadius: '16px', // Rounded corners
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Subtle shadow for depth
                margin: 'auto', // Center the image
              }}
            />
          </Box>
        </Box>
      </Container>


    </Layout>
  );
};

export default LoginPage;
